import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CompanyOfferModel, CompanyQuery } from '@fgb/core';

@Component({
  selector: 'fgbcl-offer-search-bar',
  templateUrl: './offer-search-bar.component.html',
  styleUrls: ['./offer-search-bar.component.scss'],
})
export class OfferSearchBarComponent implements OnInit {
  searchText: string;
  @Input() arrayToFilter: CompanyOfferModel[];
  @Output() searchResultArray = new EventEmitter<CompanyOfferModel[]>();
  constructor(private companyQuery: CompanyQuery) {}

  ngOnInit(): void {}

  search() {
    const companies = this.companyQuery.getAll();

    if (!this.searchText) {
      this.searchResultArray.emit(this.arrayToFilter);
      return;
    }

    const filteredCompanyIds = companies
      .filter((c) => c.DisplayName.toLocaleLowerCase().includes(this.searchText.toLocaleLowerCase().trim()))
      .map((o) => o.CompanyId);

    const filteredOffers = this.arrayToFilter.filter((o) => filteredCompanyIds.includes(o.CompanyId));

    this.searchResultArray.emit(filteredOffers);
  }
}
